exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".response-form .form__group button {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n.reply {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.reply__buttons {\n  width: 4rem;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  margin-right: 2rem;\n}\n.reply__buttons label {\n  width: 100%;\n  display: block;\n  margin-top: 1rem;\n}\n.reply__buttons label svg {\n  display: block;\n  margin: 0 auto;\n}\n.reply__fields {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}", ""]);

// exports
